export const FINANCED_OFFERS_FOR_CONTRACT_GENERATION_INVALIDATED =
  "Charisma.Leasing.PublishedLanguage.Events.LeasingDocument.ContractGeneration.FinancedOffersForContractGenerationInvalidated";
export const GENERATE_CONTRACT_FOR_DETAILS_EXECUTED =
  "Charisma.Leasing.PublishedLanguage.Events.LeasingDocument.ContractGeneration.GenerateContractForDetailsExecuted";
